export default "__VITE_ASSET__CH1sdfHD__"